/**
 * Whether the header shows the "Planned Summary" shortcut to Your Plan: for a consumer who has finished their plan, on
 * every results slide and consumer screen except Your Plan itself. Advisors and consumers still
 * working through the flow don't see it. The plan is only fetched for the consumer's own session.
 */
import { useLocation } from 'react-router-dom';
import { useIsConsumerSession } from '@/hooks/use-app-mode';
import { hasReachedFlowCompletion } from '../lib/flow-completion';
import { consumerStepPath } from '../lib/paths';
import { useConsumerPlan } from './use-consumer-plan';

export function useYourPlanShortcut(clientId: string | null | undefined) {
  const isConsumerSession = useIsConsumerSession();
  const enabled = isConsumerSession && !!clientId;
  const { plan, applications } = useConsumerPlan(clientId ?? '', { enabled });
  const { pathname } = useLocation();
  const target = clientId ? consumerStepPath(clientId, 'your-plan') : null;

  return {
    target,
    isVisible:
      enabled && !!target && pathname !== target && hasReachedFlowCompletion(plan, applications),
  };
}
